<template>
  <div id="contact">
    <p>
      I don't maintain a lot of social media.
      <ul>
        <li>
          Reddit: <a href="https://www.reddit.com/user/mainstreetmark">u/mainstreetmark</a>
        </li>
        <li>
          Blue Sky: <a href="https://bsky.app/profile/mainstreetmark.bsky.social">mainstreetmark</a>
        </li>
      </ul>
      Message me there with your thoughts and feelings.
    </p>
  </div>
</template>

<script>
export default {
	name: "contact",
	data() {
		return {};
	},
	created: function () {
		document.title = "Contact";
	},
};
</script>

<style lang="scss"></style>
